export default "__VITE_ASSET__Dw2C_lFM__"